// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import Classification from 'components/SearchAndSelect/Sets/Antenna/Classification'
import React from 'react'
import { func, string } from 'prop-types'
import { useDispatch } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { ErrorSimple, InputWithUnitToggle, LabeledInput } from 'components/Form'
import { Pagination } from '../common'
import clearAntennaValues from './clearAntennaValues'
import { AntennaLookupWrapper } from './styles'
import validate from 'validators/lookups/antenna/validate'

const Form = ({ error, form, handleSubmit }) => {
  const dispatch = useDispatch()
  return (
    <form
      className={'padding-left-1 padding-right-1 heading-font'}
      id={form}>
      <ErrorSimple
        error={error}
        idRoot={form} />
      <AntennaLookupWrapper>
        <Field
          autoFocus={true}
          className={'antenna-code'}
          component={LabeledInput}
          id={`${form}-antenna-code`}
          label={'Antenna Code'}
          placeholder={'Code'}
          name={'antennaCode'}
          type={'text'} />
        <Field
          className={'company-name'}
          component={LabeledInput}
          id={`${form}-antenna-company`}
          label={'Manufacturer'}
          name={'companyName'}
          type={'text'} />
        <Field
          className={'antenna-model'}
          component={LabeledInput}
          id={`${form}-antenna-model`}
          label={'Antenna Model'}
          placeholder={'Model'}
          name={'modelNumber'}
          type={'text'} />
        <Classification
          form={form}/>
        <InputWithUnitToggle
          className={'diameter'}
          idRoot={`${form}-diameter`}
          label={'Diameter'}
          nameRoot={'diameter'}
          placeholder={'Diameter'}
          sourceForm={form} />
        <button
          className={'antenna-lookup-search btn search-button'}
          id={`${form}-submit`}
          onClick={handleSubmit}
          type={'submit'} />
        <button
          className={'fa fa-eraser pointer clear-button'}
          id={'clearValues'}
          onClick={() => dispatch(clearAntennaValues(form))}
          type={'button'} />
      </AntennaLookupWrapper>
      <Pagination
        idRoot={`${form}-`}
        sourceForm={form} />
    </form>
  )
}

Form.propTypes = {
  change: func.isRequired,
  error: string,
  form: string.isRequired,
  handleSubmit: func.isRequired,
}

export default reduxForm({
  validate,
})(Form)
